export default __webpack_public_path__ + "static/media/autogestionicon2.586c4416.png";